import axios, { AxiosRequestConfig } from 'axios';
import { SS13OrderDayReport } from '../models/SS13OrderDayReport';
import CSharpUtils from './CSharpUtils';
import Utils from './Utils';

/**
 * SS13 Salg pr. dag: the orders of each day of a month (per order date, not invoiced) split into sales
 * and credit, compared with the same weekday last year. month = YYYYMM; butikkId = one store or a
 * comma-separated list summed together; perStore = one row per store per day. includeAccumulated = also
 * the accumulated columns, which reads every order since 1 January last year (slow) - the page asks
 * without them first.
 */
export const fetchSS13OrderDayReport = (month: string, butikkId: string, perStore: boolean, includeAccumulated: boolean) => {
  const config: AxiosRequestConfig = {
    method: 'get',
    url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/orderdays/report`,
    params: { Month: month, ButikkId: butikkId, PerStore: perStore, IncludeAccumulated: includeAccumulated },
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    responseType: 'json',
    timeout: includeAccumulated ? 120000 : 60000,
  };

  return axios.request<SS13OrderDayReport>(config);
};

export interface SS13ExportParams {
  /** The report the page has loaded - sent along, so the file is built without reading the orders again. */
  report: SS13OrderDayReport;
  /** The store selection as the page shows it, for the file's heading. */
  storeNames: string;
  /** The visible column keys, in the table's order. */
  columns: string[];
}

/** The loaded day table as an Excel or PDF file, with the visible columns. */
export const fetchSS13Export = (format: 'excel' | 'pdf', p: SS13ExportParams) => {
  const config: AxiosRequestConfig = {
    method: 'post',
    url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/orderdays/report/${format}`,
    data: { report: p.report, storeNames: p.storeNames, columns: p.columns.join(',') },
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${CSharpUtils.Get_Token}` },
    responseType: 'blob',
    timeout: 60000,
  };

  return axios.request<Blob>(config);
};
